import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var exportPdfMixin = {
  methods: {
    exportPdf(data) {

      let filename = data.title.toKebab() + '.pdf'

      let docDefinition = {
        info: {
          title: data.title,
        },
        content: [{
            text: data.title,
            style: 'header'
          },
          {
            table: {
              body: data.infos
            },
            layout: 'noBorders'
          }
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
        }
      }
      // Listes additionnelles
      if (data.lists && data.lists.length) {
        data.lists.forEach(list => {
          docDefinition.content.push({
            text: list.label,
            fontSize: 12,
            bold: true,
            margin: [0, 20, 0, 10]
          })

          // Définit la largeur de toutes les colonnes à "*" afin que la table prenne 100% de la largeur
          // de la page et que les largeurs soient automatiques
          let widths = []
          for (let index = 0; index < list.infos[0].length; index++) {
            widths.push("*")
          }
          docDefinition.content.push({
            table: {
              widths: widths,
              body: list.infos
            },
            layout: 'lightHorizontalLines'
          })
        })
      }

      if (data.extra_content_after) {
        docDefinition.content.push(...data.extra_content_after)
      }

      pdfMake.createPdf(docDefinition).download(filename);
    }
  }
}

export default exportPdfMixin;



// WEBPACK FOOTER //
// ./src/mixins/exportPdf.js